import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAllBlogPosts } from '../content/blogPosts';
import Navbar from '../components/Navbar';
import { getDownloadUrl } from '../storeLinks';

function BlogIndex() {
  const { t } = useTranslation();
  const navLinks = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.pricing'), to: '/pricing' },
    { label: t('nav.download'), to: getDownloadUrl(), external: true, cta: true },
  ];
  const posts = getAllBlogPosts();

  return (
    <div className="blog-page">
      <Navbar links={navLinks} />

      <section className="blog-hero">
        <div className="container">
          <p className="blog-eyebrow">{t('blog.eyebrow')}</p>
          <h1>{t('blog.indexHeading')}</h1>
          <p className="blog-subtitle">
            {t('blog.indexSubtitle')}
          </p>
        </div>
      </section>

      <section className="blog-listing">
        <div className="container">
          <div className="blog-grid">
            {posts.map((post) => (
              <article key={post.slug} className="blog-card">
                <p className="blog-card-meta">
                  <span>{post.date}</span>
                  <span>{post.readTime}</span>
                </p>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="blog-card-link">
                  {t('blog.readEssay')}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="footer-brand">
            <img src="/logo192.png" alt={t('landing.hero.logoAlt')} className="footer-logo" />
            <span>10 Thirty</span>
          </div>
          <p>
            {t('landing.footer.copyright', { year: new Date().getFullYear() })}{' '}
            {t('landing.footer.broughtToYou')}{' '}
            <a href="https://www.callitservices.co.za" target="_blank" rel="noopener noreferrer">{t('landing.footer.callItServices')}</a>
          </p>
          <div className="links">
            <Link to="/">{t('landing.footer.linkHome')}</Link>
            <Link to="/pricing">{t('landing.footer.linkPricing')}</Link>
            <Link to="/privacy">{t('landing.footer.linkPrivacy')}</Link>
            <Link to="/terms">{t('landing.footer.linkTerms')}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BlogIndex;
